import script from "./OurStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./OurStudents.vue?vue&type=script&setup=true&lang=js"

import "./OurStudents.vue?vue&type=style&index=0&id=4b0588cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0588cf"]])

export default __exports__